module.exports = __webpack_public_path__ + "img/ASQ.61f819db.png";